import React from 'react';
import axios from 'axios';
import { push } from 'connected-react-router/immutable';
import * as selectors from 'app/selectors/customer';
import * as actions from 'app/actions/customer';
import { Button } from 'mui';
import { useAppDispatch, useAppSelector } from 'app/helpers/hooks';
import { selectCustomer, selectPreviousStepPath } from 'app/selectors/customer';
import { LabSelection } from 'app/constants/Routes';
import { getCSRF } from 'app/api';

const useLabActions = () => {
  const dispatch = useAppDispatch();
  const reviewLabsAction = push(useAppSelector(selectPreviousStepPath));
  const labSelectionAction = push(LabSelection);
  const customer = useAppSelector(selectCustomer);
  const lab_orders = customer?.get('lab_orders')?.toArray();
  const lab_order = lab_orders?.find((order) => order.get('intake_name') === 'onboarding');
  const intake = useAppSelector(selectors.selectCurrentIntake);
  const intakeName = intake.get('name');
  const photoPurpose = `${intake.get('product_name')}_onboarding_lab`;

  const removeLabAction = actions.apiRequestUserCommand({
    cmdType: 'remove_lab_order',
    params: { lab_order_id: lab_order?.get('order_id') },
    context: { onSuccessAction: labSelectionAction },
  });

  const onCancelOwnlabs = async () => {
    await axios.post(
      '/api/commands',
      {
        user_id: customer.get('id'),
        intakeName,
        photo_purpose: photoPurpose,
        cmdType: 'delete_own_lab',
        type: 'delete_own_lab',
      },
      { headers: { 'X-CSRF-Token': getCSRF() } },
    );
    dispatch(removeLabAction);
  };

  const onReview = () => {
    dispatch(reviewLabsAction);
  };

  return { onCancelOwnlabs, onReview };
};

const OwnLabFileUploadedSection = () => {
  const { onCancelOwnlabs, onReview } = useLabActions();

  return (
    <>
      <h5 className="mb-3">Lab Testing</h5>
      <h6>Labs uploaded</h6>
      <p>
        A member of the Maximus clinical team will review your lab work within 2 business days to ensure lab criteria
        are met. If lab criteria are not met you will be contacted by a member of the concierge team.
      </p>
      <Button onClick={onReview}>Review Labs</Button>
      <Button variant="text" onClick={onCancelOwnlabs}>
        Cancel Using Own Labs
      </Button>
    </>
  );
};

export default OwnLabFileUploadedSection;
